// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"48db0991","833":"4d59fdc6","985":"5be90f7e"}[chunkId] + ".chunk.js";
};